<ng-container [formGroup]="formGroupContainer">
  <mood-admin-config-fieldset formArrayName="files" legendTitle="Output files">
    <div class="description">
      <p>Any raster values configured here will override the default values for this layer only.</p>
    </div>

    <div *ngFor="let fileGroup of filesArray.controls; let i=index">
      <mat-divider *ngIf="i !== 0"></mat-divider>

      <mood-admin-grouped-file-form [formGroupName]="i"></mood-admin-grouped-file-form>
    </div>
  </mood-admin-config-fieldset>
</ng-container>
